import React, { Component } from "react";
import { connect } from "react-redux";
import { selectFilter } from "../../actions"
import Collapse from '@mui/material/Collapse';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatAs, DateFnsFormats } from "../../../../common-client2/src/services/ukgDateTime";
import { getValidationFailureMessages } from "../../../Utils/ValidationFailureFormatter";

class HistoryPanel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      opened: false
    }
  }


  toggleCollapsable() {
    this.setState({
      opened: 1 - this.state.opened
    });
  }


  generateHistory() {
    let { classes, t, history, managerSettingNames, handleClick = () => { } } = this.props;
    let { opened } = this.state;
    let historySections = [];

    historySections.push(<hr />);
    historySections.push(
      <div className={classes.filterTitle} onClick={() => { this.toggleCollapsable() }}>
        {t('billboard.history')}
        <FontAwesomeIcon icon={opened ? faAngleUp : faAngleDown} style={{ float: "right", marginRight: "10px" }} />
      </div>
    );

    let elements = [];
    for (const item of history) {
      const failureMessages = getValidationFailureMessages(item, t);
      const hasValidationFailures = failureMessages.length > 0;

      elements.push(
        <div
          onClick={() => handleClick(item)}
          key={'historyLog' + item.offerId}
          className={classes.historyItemContainer}
          style={{
            border: hasValidationFailures ? '2px solid #f44336' : 'none',
            borderRadius: hasValidationFailures ? '4px' : '0',
            backgroundColor: hasValidationFailures ? '#ffebee' : 'transparent',
            padding: hasValidationFailures ? '8px' : '0'
          }}
        >
          <div className={classes.historyLogFirst}>
            <span className={classes.historyLogName}>{item.employeeName} </span>
            <span>{item.status} </span>
            <span className={classes.historyLogshiftTime}>{managerSettingNames[item.managerSettingId]}</span>
          </div>
          <div className={classes.historyLogDate}>{formatAs(item.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)}</div>
          {hasValidationFailures && (
            <div style={{ marginTop: '8px', color: '#d32f2f' }}>
              <div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
                {t('validationFailureDetails.historyTitle')}
              </div>
              <ul style={{ margin: '0', paddingLeft: '16px', fontSize: '11px' }}>
                {failureMessages.map((message, failureIndex) => (
                  <li key={`validation-${item.offerId}-${failureIndex}`} style={{ marginBottom: '2px' }}>
                    {message}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );
    }

    historySections.push(
      <Collapse
        in={opened}
        timeout={{ enter: 750, exit: 750 }}
        style={{ transitionDelay: "250ms" }}
      >
        {elements}
      </Collapse>
    );



    return historySections;
  }


  render() {
    return <div>{this.generateHistory()}</div>;
  }
}

const mapStateToProps = state => {
  return {
    history: state.data.globalHistory,
    managerSettingNames: state.managerSettingNames
  };
};

export default connect(mapStateToProps, { selectFilter })(HistoryPanel);
